import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, FormControlLabel, Checkbox, FormGroup, FormHelperText } from '@mui/material';

const ExteriorSignageQuoteTermConditions = ({ exteriorSignageQuote, isDisabled, validator, agreements, setAgreements }) => {
  const { t } = useTranslation();

  const hasAcceptedDate = !!exteriorSignageQuote?.termsConditionsAcceptedDate;

  const handleChange = event => {
    setAgreements({
      ...agreements,
      [event.target.name]: event.target.checked,
    });
  };

  const renderCheckbox = (name, titleKey, detailsKey) => {
    const isChecked = isDisabled ? hasAcceptedDate : agreements[name];

    const errorMessage =
      !isDisabled &&
      validator?.current?.message(name, agreements[name], 'accepted', {
        messages: { accepted: t('requiredCheckboxError') },
      });

    return (
      <Box sx={{ mb: 3 }}>
        <FormControlLabel
          control={
            <Checkbox
              id={`checkbox-${name}`}
              checked={isChecked}
              onChange={handleChange}
              name={name}
              color="primary"
              disabled={isDisabled}
              sx={{ p: 0, mr: 2, mt: 0.3 }}
              inputProps={{
                'aria-describedby': detailsKey ? `details-${name}` : undefined,
              }}
            />
          }
          label={
            <Typography
              sx={{
                fontWeight: 'bold',
                color: isDisabled ? 'text.disabled' : 'text.primary',
              }}>
              {t(titleKey)}
            </Typography>
          }
          sx={{ alignItems: 'flex-start', m: 0 }}
        />

        {detailsKey && (
          <Box
            id={`details-${name}`}
            sx={{
              ml: 8,
              mt: 1,
              color: isDisabled ? 'text.disabled' : 'text.primary',
            }}
            dangerouslySetInnerHTML={{ __html: t(detailsKey) }}
          />
        )}

        {errorMessage && (
          <FormHelperText error sx={{ ml: 8, mt: 1 }}>
            {errorMessage}
          </FormHelperText>
        )}
      </Box>
    );
  };

  return (
    <Box>
      <Typography variant="h1" sx={{ mb: 3 }}>
        {t('termsConditions')}
      </Typography>

      <FormGroup>
        {renderCheckbox('siteVerification', 'termsSiteVerificationTitle', 'termsSiteVerificationDetails')}
        {renderCheckbox('noReimbursement', 'termsNoReimbursementTitle', 'termsNoReimbursementDetails')}
        {renderCheckbox('permitApplication', 'termsPermitApplicationTitle', 'termsPermitApplicationDetails')}
        {renderCheckbox('municipalCompliance', 'termsMunicipalComplianceTitle', 'termsMunicipalComplianceDetails')}
        {renderCheckbox('timelines', 'termsTimelinesTitle', 'termsTimelinesDetails')}
        {renderCheckbox('oemParity', 'termsOemParityTitle', 'termsOemParityDetails')}
      </FormGroup>
    </Box>
  );
};

export default ExteriorSignageQuoteTermConditions;
